import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { LoginCandidateComponent } from './components/login-candidate/login-candidate.component';
import { RegisterComponent } from './components/register/register.component';
import { RecoverPasswordCandidateComponent } from './components/login-candidate/recover-password-candidate/recover-password-candidate.component';
import { ChangePasswordComponent } from '../employee/pages/change-password/change-password.component';

const routes: Routes = [
  { path: '', redirectTo: 'login-candidate', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'login-candidate', component: LoginCandidateComponent },
  { path: 'recover', component: RecoverPasswordCandidateComponent },
  { path: 'change_password', component: ChangePasswordComponent },
  { path: 'register', component: RegisterComponent },
  { path: '**', redirectTo: 'login-candidate', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MultiLoginRoutingModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/multi-login-routing.module.ts